<template>
  <div class="before-apply" v-show="showHolePage">
    <van-popup class="contract-popup" v-if="showContract" v-model="showContract" position="bottom" duration="0.1" transition="none">
      <div class="contract-box">
        <!-- <div class="contract-title">《患者知情同意书》</div> -->
        <div class="contract-text" id="text" >
          <div v-html="contractText"></div>
          
        </div>
        
        <div class="contract-btn">
          <div class="contract-agree">
            <van-checkbox :value="agree" @click.native="agreeClick" icon-size="16px" color="#0AA8AF">
               <template #icon="">
                <img class="img-icon" :src="agree ? '/static/beforeApply/chosen.png' : '/static/beforeApply/unchosen.png' " />
              </template>
              
              我已阅读并同意《患者知情同意书》</van-checkbox>
            <div class="buttons">
              <van-button style="margin-right: 10px;" type="info" plain round @click="back" color="#0AA8AF">取消</van-button>
              <van-button class="flex-1" type="info" v-if="agree&&checked"  round @click="sign" color="#0AA8AF">同意并继续</van-button>
              <van-button class="flex-1" type="info" v-else round disabled @click="sign" color="#0AA8AF">同意并继续<template v-if="showTimes">({{times}}秒)</template></van-button>
            </div>
          </div>
          <!-- <div class="agree-box" v-if="checked&&bottom"></div>
          <div class="agree-box" v-else> 请阅读并拉到底部({{times}}秒) </div> -->
          <!-- <van-button v-if="checked&&bottom" type="info" :disabled="submitBtnDisabled" block @click="sign" color="#0AA8AF">我已阅读并同意《患者知情同意书》</van-button>
          <van-button v-else type="info" :disabled="true" block color="#0AA8AF">我已阅读并同意《患者知情同意书》({{times}}秒)</van-button> -->
        </div>
      </div>
    </van-popup>



        <div  class="canvas-page" @touchmove.prevent >
          <div class="canvas-title">患者知情同意书签字</div>
          <div class="canvas-box" id="canvas-box">
            <!-- <canvas id="canvas" width="300" height="600">Canvas画板</canvas> -->
            <div class="canvas-tips">若签名板功能出现异常，请尝试”刷新“页面重试。</div>
            <canvas id="canvas">Canvas画板</canvas>
          </div>
        </div>

        <div  class="page-ft" >
          <van-row gutter="20" class="canvas-btn">
            <van-col span="8">
              <van-button @click.native="clear" block round type="warning" color="#0AA8AF">清除</van-button>
            </van-col>
            <van-col span="16">
              <van-button :disabled="submitBtnDisabled" @click.native="save" block round type="info" color="#0AA8AF">提交</van-button>
            </van-col>
          </van-row>
        </div>

  </div>
</template>

<script>
  import {
    checkin,
    UploadContract,
    IdcardOcr,
    PatientConfig
  } from "../../api/api";

  import {
    mapState
  } from "vuex";
  import Vue from "vue";
  import {
    Toast,
    Dialog
  } from "vant";

  Vue.use(Toast);
  Vue.use(Dialog);

  var draw;
  var isDraw = false;
  var preHandler = function (e) {
    e.preventDefault();
  };
  class Draw {
    constructor(el) {
      this.el = el;
      this.canvas = document.getElementById(this.el);
        
      this.cxt = this.canvas.getContext("2d");
      this.cw = document.getElementById("canvas-box").clientWidth - 30;
      this.ch = document.getElementById("canvas-box").clientHeight - 30;
      console.log("cw,ch",document.getElementById("canvas-box").clientWidth,document.getElementById("canvas-box").clientHeight)
      this.canvas.width = this.cw;
      this.canvas.height = this.ch;
      this.stage_info = canvas.getBoundingClientRect();
      this.path = {
        beginX: 0,
        beginY: 0,
        endX: 0,
        endY: 0
      };
    }
    init(btn) {
      var that = this;

      this.canvas.addEventListener("touchstart", function (event) {
        document.addEventListener("touchstart", preHandler, false);
        that.drawBegin(event);
      });
      this.canvas.addEventListener("touchend", function (event) {
        document.addEventListener("touchend", preHandler, false);
        that.drawEnd();
      });
      this.clear(btn);
    }
    drawBegin(e) {
      var that = this;
      window.getSelection() ?
        window.getSelection().removeAllRanges() :
        document.selection.empty();
      this.cxt.strokeStyle = "#000";
      this.cxt.lineWidth = 2
      this.cxt.beginPath();
      this.cxt.moveTo(
        e.changedTouches[0].clientX - this.stage_info.left,
        e.changedTouches[0].clientY - this.stage_info.top
      );
      this.path.beginX = e.changedTouches[0].clientX - this.stage_info.left;
      this.path.beginY = e.changedTouches[0].clientY - this.stage_info.top;
      canvas.addEventListener("touchmove", function () {
        that.drawing(event);
      });
    }
    drawing(e) {
      this.cxt.lineTo(
        e.changedTouches[0].clientX - this.stage_info.left,
        e.changedTouches[0].clientY - this.stage_info.top
      );
      this.path.endX = e.changedTouches[0].clientX - this.stage_info.left;
      this.path.endY = e.changedTouches[0].clientY - this.stage_info.top;
      this.cxt.stroke();
    }
    drawEnd() {
      document.removeEventListener("touchstart", preHandler, false);
      document.removeEventListener("touchend", preHandler, false);
      document.removeEventListener("touchmove", preHandler, false);
      //canvas.ontouchmove = canvas.ontouchend = null
      isDraw = true;
    }
    clear(btn) {
      this.cxt.clearRect(0, 0, this.cw, this.ch);
      isDraw = false;
    }
    save() {
      return canvas.toDataURL("image/png");
    }
  }

  export default {
    data() {
      return {
        showHolePage:false,
        agree:false,//点击同意
        checked:false,//是否看了5秒
        bottom:false,//是否到底
        contractText:"",//知情同意书
        timer:null,//计时器
        times:5,//倒计时15s
        showTimes: false, // 显示倒计时
        showContract:true,
        canvas:null,//,
        reason: "",
        status: "",

        patient_id: "",
        signature_image: "",
        submitBtnDisabled: false,
      };
    },
    computed: {
      ...mapState(['patientOne', 'userInfo']),
    },
    async created() {
      this.patient_id = this.$route.query.patientid;
      console.log("this.patient_id",this.patient_id)
      this.reason = this.$route.query.reason;
      this.status = this.$route.query.status;
      if (this.patientOne) {
        if (this.patientOne.signature_image && this.status != '未上传') this.signature_image = this.patientOne.signature_image
      }
    },
    async mounted() {
        await PatientConfig()
        .then(res => {
          this.contractText = res.data.contract_text;
        })
        .catch(err => {
          Toast(err.response.data.message);
        });
        this.showHolePage=true;
        this.getTime();
        this.touchBottom();//监听滚动到底部
    },
    methods: {
      touchBottom(){
        let text = document.getElementById("text");
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        console.log("text",text)
        text.onscroll = () => {
        // 获取距离顶部的距离
            let scrollTop = text.scrollTop;
            // 获取可视区的高度
            let windowHeight = text.clientHeight;
            // 获取滚动条的总高度
            let scrollHeight = text.scrollHeight;
            console.log("scrollTop",scrollTop)
            // console.log("windowHeight",windowHeight)
            // console.log("scrollHeight",scrollHeight)
            console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            if(scrollTop+windowHeight>=scrollHeight-200){
                // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
                this.bottom = true
            }
        }
      },
      clear: function () {
        draw.clear();
      },
      save: async function () {
        if (isDraw) {
          var data = draw.save();
          // console.log("签名", data);
          this.signature_image = data;
          let self = this;
          if (!this.signature_image) {
            Toast("请先手写签名");
            return;
          }
          self.submitBtnDisabled = true;
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true
          });
          UploadContract({
              patient_id: self.patient_id,
              signature_image: self.signature_image
            })
            .then(res => {
              self.submitBtnDisabled = false;
              Toast.clear();
              if(res){
                this.$router.replace({
                  name: "Blank"
                });
                return;
              }
            })
            .catch(err => {
              self.submitBtnDisabled = false;
              Toast.clear();
              Toast(err.response.data.message);
            });
        } else {
          Toast({
            message: "请先手写签名再点击”保存“",
            duration: 1000
          });
        }
      },
      mutate(word) {
        this.$emit("input", word);
      },
      touchmove: function () {
        document.body.addEventListener(
          "touchmove",
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          }, {
            passive: false
          }
        );
      },
      getTime() {
        this.showTimes = true
        this.checked = false
        this.timer = setInterval(()=>{
          this.times--
          if(this.times===0){
            this.checked = true
            clearInterval(this.timer)
            setTimeout(() => {
              this.showTimes = false
            }, 1000);
          }
        },1000)
      },
      agreeClick() {
        console.log('agree', this.showTimes, this.agree)
        if (!this.showTimes) {
          this.agree = !this.agree
        } else {
          console.log('agree22222')
          // this.$toast.clear(true)
          // this.$toast({message:'请阅读完患者知情同意书后再进行勾选',className:'z-index-top'})
        }
      },
      sign(){
          this.showContract=false;
          draw = new Draw("canvas");
          draw.init();
          if (this.status) {
          Dialog.alert({
            title: '知情同意书签名' + this.status,
            message: '原因：' + this.reason + '<br/>请重新签名!',
          }).then(() => {
            // on close
          });
        }
      },
      back(){
        this.$router.push({name: "Timeline"})
      }
  
    }
  };
</script>
<style lang='less' >
  .before-apply {
    text-align: center;
    padding-bottom: 74px;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .contract-popup {
      border-radius:0;
      height: 100%;
      margin: 0;
      width: auto;
      box-sizing: border-box;
      overflow: hidden;
      z-index:99999 !important;
    }

    .contract-box {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;

      .contract-title {
        background: #fff;
        box-sizing: content-box;
        width: auto;
        line-height: 24px;
        height: 24px;
        font-size: 1.6rem;
        text-align: center;
        padding: 20px 50px 10px;
        background: #fff;
      }

      .contract-text {
        // margin-bottom: 20px;
        flex: 1;
        // height: 50%;
        font-size: 1.4rem;
        text-align: justify;
        // text-align-last: left;
        line-height: 1.5;
        height: 100%;
        padding: 15px;
        overflow-y: auto;
        transition: transform .3s;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 160px;
      }

      .contract-btn {
        background: #fff;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;

        .agree-box {
          font-size: 14px;
          // height: 40px;
          line-height: 20px;
          padding: 10px;
          text-align: center !important;
          vertical-align: middle;

          .van-checkbox {
            justify-content: center;
          }
        }
      }
      .contract-agree{
        margin: 10px 10px 0 10px;
        padding-bottom:40px;
        .buttons{
          display: flex;
          justify-content:space-between;
          margin: 15px 0;
          .van-button{
            width: 35vw;
          }
        }
      }
    }

    .canvas-title {
      height: 48px;
      line-height: 48px;
      font-size: 1.6rem;
      position: relative;

      &::after {
        .b-line;
      }
    }

    .canvas-box {
      height: calc(100vh - 122px);
      position: relative;

      .canvas-tips {
        line-height: 20px;
        background: rgba(@blue, 0.6);
        position: absolute;
        bottom: 14px;
        left: 15px;
        right: 15px;
        color: #fff;
      }
    }

    #canvas {
      background: lighten(@theme-color, 40%) center center no-repeat;
      background-image: url("../../assets/broad_bg.jpg") !important;
      background-size: auto 75%;
      border: lighten(@theme-color, 30%) solid 1px;
      cursor: default;
      margin: 15px auto;
      // position: absolute;
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
      // margin: auto;
    }

    .canvas-btn {
      padding: 15px;
      background: #fff;
      z-index: 3002;
    }

    .idcard-btn {
      padding: 15px;
      background: #fff;
      z-index: 3003;
    }
    .page-ft{
        position: fixed;
        min-height: 30px;
        width: 100%;
        left: 0;
        bottom: 0;
        z-index: 5;
    }
  }
.z-index-top{
  z-index:999999999 !important;
}
</style>
